import { Typography } from '@mui/material'
import { Wrapper } from './FormCountResults.styles'
import { useContextSelector } from 'use-context-selector'
import { pageview } from '@utils/functions/pageview/pageview'
import { SearchResultsContext } from '@pages/private/SearchResults/context'
import { decodeKeywords } from '@utils/functions/keyword/serialize'
import { KeywordRender } from '@components/atoms'

function FormCountResultsComponent() {
  const keyword = useContextSelector(SearchResultsContext, (s) => s.keyword)
  const keywords = decodeKeywords(keyword)

  const pagination = useContextSelector(
    SearchResultsContext,
    (s) => s.pagination
  )
  return (
    <Wrapper>
      <Typography variant="$font-body-base" color="$color-text-primary">
        <Typography variant="$font-body-base" color="$color-text-primary" sx={{ float: "left"}}>
          Exibindo {pageview(pagination || {})} resultados{' '}
          {keyword && `para`} &nbsp;
        </Typography>
        <KeywordRender value={{ keywords }} tiny inline envolve={[`"`,`"`]}/>
      </Typography>
      
    </Wrapper>
  )
}

export default FormCountResultsComponent
